import axios, { AxiosResponse } from "axios";
import { processApiResponseSafe } from "@/shared/utils/errorHandler";

const baseURL = process.env.NEXT_PUBLIC_PLATFORM === 'PC' ? process.env.NEXT_PUBLIC_FE_PC_URL : process.env.NEXT_PUBLIC_FE_M_URL;

// 로컬
export const apiFe = axios.create({
  baseURL: `${baseURL}/api`,
  timeout: 30_000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// 전역 로딩 인터셉터 (간단 버전: 특정 헤더 있을 때만 로딩 표시 + 참조 카운트)
let pendingRequestCount = 0;

apiFe.interceptors.request.use((config) => {
  // 클라이언트 사이드에서만 로딩 스토어 접근
  if (typeof window !== 'undefined') {
    try {
      const { useLoadingStore } = require("@/shared/store/loading");
      const { show } = useLoadingStore.getState();
      const headers: any = (config.headers || {}) as any;
      const headerLoading = headers['x-loading'] === 'true' || headers['X-Loading'] === 'true' || headers['x-loading'] === true;

      if (headerLoading) {
        // 클라이언트 전용 플래그 저장 및 서버로는 헤더 미전달
        (config as any).__forceLoading = true;
        if (headers['x-loading'] !== undefined) delete headers['x-loading'];
        if (headers['X-Loading'] !== undefined) delete headers['X-Loading'];
        config.headers = headers;

        pendingRequestCount += 1;
        show();
      }
    } catch (error) {
      // 서버 사이드에서는 무시
      console.warn('Loading store not available on server side');
    }
  }
  return config;
});

apiFe.interceptors.response.use(
  async <T>(response: AxiosResponse<T>) => {
    // 클라이언트 사이드에서만 로딩 스토어 접근
    if (typeof window !== 'undefined') {
      try {
        const { useLoadingStore } = require("@/shared/store/loading");
        const { hide } = useLoadingStore.getState();
        const force = (response.config as any).__forceLoading === true;
        if (force) {
          pendingRequestCount = Math.max(0, pendingRequestCount - 1);
          if (pendingRequestCount === 0) hide();
        }
      } catch (error) {
        // 서버 사이드에서는 무시
        console.warn('Loading store not available on server side');
      }
    }
    // 중앙 집중식 에러 처리 시스템 적용 (환경 안전)
    const data = response.data as any;
    if (data && data.result_code) {
      processApiResponseSafe(data);
    }
    return response;
  }, // 2xx 범위일 때
  (error) => {
    // 클라이언트 사이드에서만 로딩 스토어 접근
    if (typeof window !== 'undefined') {
      try {
        const { useLoadingStore } = require("@/shared/store/loading");
        const { hide } = useLoadingStore.getState();
        const config = error?.config || {};
        const force = (config as any).__forceLoading === true;
        if (force) {
          pendingRequestCount = Math.max(0, pendingRequestCount - 1);
          if (pendingRequestCount === 0) hide();
        }
      } catch (error) {
        // 서버 사이드에서는 무시
        console.warn('Loading store not available on server side');
      }
    }
    return Promise.reject(error);
  }
);
